import { createSlice } from "@reduxjs/toolkit";
import { PagedData } from '@/Interfaces/_';
import { UserVerifyData } from "@/Interfaces/I_userVerify";

interface userVerifyState {
  value: {
    userRoles: PagedData<UserVerifyData>,
  },
  loading: boolean;
  error: string | null;
}

const initialState: userVerifyState = {
  value: {
    userRoles: {} as PagedData<UserVerifyData>
  },
  loading: false,
  error: null,
};

const userVerifySlice = createSlice({
  name: 'userVerify',
  initialState,
  reducers: {
    getUserVerify: (state, action) => {
      const assignState = state;
      assignState.loading = true;
    },
    setUserVerify: (state, action) => {
      const assignState = state;
      assignState.value = { ...assignState.value, userRoles: action.payload.data };
      assignState.loading = false;
    },
    putUserVerify: (state, action) => {
      const assignState = state;
    },
    putUserVerifySucess: (state, action) => {
      const assignState = state;
      assignState.value.userRoles.data = assignState.value.userRoles.data.concat(action.payload);
      assignState.value.userRoles.pagination.total += action.payload.length;
    },
    deleteUserVerify: (state, action) => {
      const assignState = state;
      assignState.loading = true;
    },
  },
});

export const { 
  getUserVerify,
  setUserVerify,
  putUserVerify,
  putUserVerifySucess,
  deleteUserVerify,
} = userVerifySlice.actions;

export default userVerifySlice.reducer;